import moment from 'moment';
import _includes from 'lodash/includes';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, $stateParams, $rootScope, $state, $timeout, modalService, inventorySearch, metaTagService, utilsService, tracking) {
  metaTagService.set({
    title: 'Find your night | Tablelist',
    description: 'Search nightlife. Bottle Service, Tickets, Tables and Packages',
    facebookImage: $scope.featuredImage
  });

  $scope.loading = true;

  $scope.form = {
    cityId: $stateParams.cityId || utilsService.defaultCityId(),
    guestsMin: $stateParams.guestsMin,
    guestsMax: $stateParams.guestsMax,
    date: $stateParams.date || moment().valueOf()
  };

  $scope.limitTo = null;

  $scope.limitToOptions = {
    tickets: ['TICKET', 'COVER'],
    tables: ['TABLE', 'PACKAGE']
  };

  $scope.limitToType = function(type) {
    $scope.limitTo = ($scope.limitTo === type) ? null : type;
  };

  $scope.filterInventory = function(inventoryItem) {
    if (!$scope.limitTo) return true;

    const allowedInventory = $scope.limitToOptions[$scope.limitTo];

    return _includes(allowedInventory, inventoryItem.type);
  };

  _getInventorySummaries();

  function _getInventorySummaries() {
    const date = moment($scope.form.date, 'x');

    const options = {
      cityId: $scope.form.cityId,
      guestMin: $scope.form.guestsMin,
      guestMax: $scope.form.guestsMax,
      start: date.startOf('day').valueOf(),
      end: date.endOf('day').valueOf()
    };

    tracking.trackEvent(SEGMENT_EVENTS.SearchedInventory, options);

    inventorySearch.getInventorySummaries(options, function success(resp) {

      $scope.inventorySummaries = resp;

      $timeout(function() {
        $scope.loading = false;
      }, 400);

    }, function() {

    });
  }

  $scope.concierge = function() {
    const msg = 'Hello Tablelist Concierge, I\'m browsing the tablelist website, and was wondering if you could help me with suggestions for my night out.';

    modalService.contactSupport({
      message: msg
    });
  };

  $scope.buyInventory = function(inventory, venue) {
    if (!inventory || !venue) return;

    if (inventory.quantity.quantity < 1) return;

    const options = {
      inventory: inventory.id,
      guests: inventory.guests,
      venue: venue,
      startDate: moment(Number($scope.form.date), 'x').hour(6)
        .minute(0)
        .utc()
        .toDate()
        .getTime()
    };

    const trackingData = {};
    trackingData.venue = venue.name;
    trackingData.type = inventory.type;

    tracking.trackEvent(SEGMENT_EVENTS.StartedOrder, trackingData);

    modalService.bookingWidget(options);
  };
}

Ctrl.$inject = [
  '$scope',
  '$stateParams',
  '$rootScope',
  '$state',
  '$timeout',
  'modalService',
  'inventorySearchService',
  'metaTagService',
  'utilsService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/search/searchCtrl.js